module.exports = {
      id: "googleplay-usage",
      viewBox: "0 0 135 40",
      url: __webpack_public_path__ + "svg-sprite-e76c2ea32079628f8a8c5156f1fd5f59.svg#googleplay",
      toString: function () {
        return this.url;
      }
    }